import { createSelector } from 'reselect';

import { getBuilder } from './getBuilder';

export const getRobotStatistics = createSelector(
  getBuilder,
  builder => builder.statistics
);
